import React, { Component, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { CustomErrorPage } from '../catalog/CustomErrorPage';

interface Props {
  children: ReactNode;
  location: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

// Catches render-time throws. Resets on route change.
class ErrorBoundaryCore extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  // Triggered when any child component throws during render → renders ErrorPage
  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidUpdate(prevProps: Props) {
    if (this.state.hasError && prevProps.location !== this.props.location) {
      this.setState({ hasError: false, error: null });
    }
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <CustomErrorPage
          resetError={() => this.setState({ hasError: false, error: null })}
        />
      );
    }
    return <>{this.props.children}</>;
  }
}

export function GlobalErrorBoundary({ children }: { children: ReactNode }) {
  const location = useLocation();
  return <ErrorBoundaryCore location={location.pathname}>{children}</ErrorBoundaryCore>;
}
